(ns teamoesterreich.setup
  (:require [teamoesterreich.config :as config]))


(def config
  (js->clj config/raw-config {:keywordize-keys true}))



(def USER_DOCUMENT_TYPES
  {
   "profilePicture"        "Profilbild"
   "identification"        "Ausweis"
   "selfDeclaration"       "Selbsterklärung"
   "lebensretter-qualification" "Lebensretter Qualifikation"
   ""                      "Sonstiges"
   })